import React, { Component, Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { Alert, Box, Button, LinearProgress, Stack, Typography } from '@mui/material';

export const PageLoading = () => (
  <Box role="status" aria-label="Ładowanie strony" sx={{ py: 2 }}>
    <LinearProgress />
    <Typography sx={{ mt: 2, textAlign: 'center' }}>Ładowanie...</Typography>
  </Box>
);

class RouteErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) { return { error }; }

  render() {
    if (this.state.error) {
      return (
        <Stack spacing={2} sx={{ p: 2 }}>
          <Alert severity="error">Nie udało się wczytać strony. Sprawdź połączenie i spróbuj ponownie.</Alert>
          <Button variant="outlined" onClick={() => window.location.reload()}>Odśwież stronę</Button>
        </Stack>
      );
    }
    return this.props.children;
  }
}

export default function RouteContent({ children }) {
  const { pathname } = useLocation();
  return (
    <RouteErrorBoundary key={pathname}>
      <Suspense fallback={<PageLoading />}>{children}</Suspense>
    </RouteErrorBoundary>
  );
}
